var _rect, _rect2, _path, _path2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 99.7,
    height: 99.7,
    rx: 49.85,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(26 26)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 50.9258C52.8443 50.9258 55.6217 49.2 57.8207 46.0662C59.7614 43.3008 60.9199 39.8816 60.9199 36.9199C60.92 30.8987 56.0212 26 50 26C43.9788 26 39.0801 30.8987 39.0801 36.9199C39.0801 39.8816 40.2386 43.3008 42.1792 46.0662C44.3782 49.2 47.1557 50.9258 50 50.9258Z",
    fill: "#C1C9B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0016 55.81C64.0775 52.8239 61.3689 50.4403 58.1683 48.9167C57.8283 48.7549 57.4235 48.8243 57.1568 49.0901C55.0116 51.2294 52.5367 52.36 49.9995 52.36C47.4619 52.36 44.9873 51.2294 42.8434 49.0903C42.5768 48.8242 42.1717 48.7547 41.8319 48.9166C38.6312 50.4402 35.9223 52.8239 33.998 55.8098C32.0213 58.8769 30.9766 62.4354 30.9766 66.1003V66.1158C30.9766 66.3669 31.0827 66.6065 31.2687 66.7753C36.406 71.4343 43.058 74.0001 49.9994 74.0001C56.9407 74.0001 63.5926 71.4343 68.73 66.7753C68.916 66.6065 69.0221 66.3671 69.0221 66.1158V66.1003C69.0224 62.4354 67.9779 58.8769 66.0016 55.81Z",
    fill: "#C1C9B6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.15,
    y: 0.15,
    width: 99.7,
    height: 99.7,
    rx: 49.85,
    stroke: "#C1C9B6",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoProfile);
export default __webpack_public_path__ + "static/media/Photo_profile.6bec78a3786f4436c28e91b9ce745292.svg";
export { ForwardRef as ReactComponent };